import React from 'react';
import {
    Paper,
    Typography,
    Box
} from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/Error';
import SearchIcon from '@material-ui/icons/Search';
import { withStyles } from '@material-ui/core/styles';
import CustomButton from "../common/customButton";

const styles = theme => ({
    card: {
        backgroundColor: "#ffffff",
        color: "#212529",
        border: "1px solid #0000002d",
        borderRadius: 8,
        margin: "1em auto 0",
        padding: "1em",
        transition: "background 0.2s ease",
        boxShadow: "0 0.125rem 0.25rem rgba(0, 0, 0, 0.075)",
    },
    mobileCard: {
        display: "flex",
        alignItems: "start",
        flexDirection: "column",
    },
    desktopCard: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
    },
    cardContent: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        gap: "1rem",
        marginBottom: "0",
    },
    mobileCardContent: {
        alignItems: "start",
        flexDirection: "column",
        marginBottom: "0.5rem",
    },
    cardText: {
        color: "#212529",
        minWidth: 120,
        fontSize: "1rem"
    },
    normalText: {
        color: "#212529"
    },
    pendingText: {
        color: "#FF0000"
    },
    errorIcon: {
        color: "#dc3545",
        fontSize: "calc(1.275rem + .3vw)!important",
    },
    searchIcon: {
        fontSize: "1.25rem"
    }
});

const EquipamentsPageCard = ({
    classes,
    isMobile,
    equipamento,
    onDetailsClick,
    currentLanguage
}) => {
    const isPending = !equipamento.proxima_revisao ||
        new Date(equipamento.proxima_revisao) < new Date();

    const cardData = [
        {
            title: `${currentLanguage.bepiService.shared.shared_equip_card_code_label}: `,
            content: equipamento.id || "---",
            pending: false
        },
        {
            title: `${currentLanguage.bepiService.shared.shared_equip_card_item_label}: `,
            content: equipamento.nome || "---",
            pending: false
        },
        {
            title: `${currentLanguage.bepiService.shared.shared_equip_card_last_rev_label}: `,
            content: equipamento.ultima_revisao || "---",
            pending: false
        },
        {
            title: `${currentLanguage.bepiService.shared.shared_equip_card_next_rev_label}: `,
            content: isPending ? currentLanguage.bepiService.shared.shared_equip_card_pending_status : equipamento.proxima_revisao,
            pending: isPending
        },
        {
            title: false,
            content: [equipamento.marca || "---", equipamento.modelo || "---", equipamento.serie || "---"],
            pending: false
        }
    ];

    const cardContent = (
        <>
            <Box
                className={`${classes.cardContent} ${isMobile ? classes.mobileCardContent : ''}`}
                style={{
                    marginLeft: isMobile || isPending ? "0" : "1em",
                }}
            >
                <Box textAlign="center">
                    {isPending && <ErrorIcon className={classes.errorIcon} />}
                </Box>
                <Box className={classes.cardText}>
                    {cardData.map((item, index) => (
                        <Typography key={index} className={classes.normalText}>
                            {item.title && <b>{item.title}</b>}
                            {Array.isArray(item.content) ? (
                                <>🎲 <i>{item.content[0]}</i> | <i>{item.content[1]}</i> | <i>{item.content[2]}</i></>
                            ) : (
                                <span className={item.pending ? classes.pendingText : classes.normalText}>
                                    {item.content}
                                </span>
                            )}
                        </Typography>
                    ))}
                </Box>
            </Box>
            <Box display="flex">
                <CustomButton
                    variant="grayOutlined"
                    size="small"
                    icon={<SearchIcon className={classes.searchIcon} />}
                    onClick={onDetailsClick}
                >
                    {currentLanguage.bepiService.shared.shared_equip_card_details_btn}
                </CustomButton>
            </Box>
        </>
    );

    if (isMobile) {
        return (
            <Paper
                key={equipamento.id}
                className={`${classes.card} ${classes.mobileCard}`}
                elevation={0}
            >
                {cardContent}
            </Paper>
        );
    } else {
        return (
            <Paper
                key={equipamento.id}
                className={`${classes.card} ${classes.desktopCard}`}
                elevation={0}
            >
                {cardContent}
            </Paper>
        );
    }
};

export default withStyles(styles)(EquipamentsPageCard);
